import Logo from './assets/logo.svg'
import './styles/app.scss'

function App() {
  return (
    <div className='App'>
      <div className='Logo'>
        <img src={Logo} alt='FF3D' />
        <span>FF3D</span>
        Software Engineering
      </div>
      <div className='Contacts'>
        FF3D.COM s.r.l.
        <br />
        Via al Lago 6/A
        <br />
        23900 Lecco
        <br />
        <br />
        <i className='fas fa-phone'></i>
        <a href='tel:+3903411895220' className='Lnk'>
          +39 0341 1895220
        </a>
        <br />
        <i className='fas fa-fax'></i>
        <a href='tel:+3903411895251' className='Lnk'>
          +39 0341 1895251
        </a>
        <br />
        <i className='far fa-envelope'></i>
        <a href='mailto:info@ff3d.com' className='Lnk'>
          info@ff3d.com
        </a>
        <br />
        <br />
        P.I. 02588710133
      </div>
    </div>
  )
}

export default App
